import { withStyles } from '@mui/styles';
import Header from './header';
import { styles } from './header.styles';

export default withStyles(styles, { withTheme: true })(Header);
